const AppConstants = {
  SHOW_MORE_INTEGRATIONS_LIMIT: 12,
  BOT: 'bot',
  KEY_CODE: {
    ENTER: 'Enter',
    CHANGE: 'change',
    CLICK: 'click',
    BLUR: 'blur',
    KEYDOWN: 'keydown',
  },
  DELETED: '[Deleted]',
  ENABLED: 'ENABLED',
  AI_TNC: 'AI_TNC',
  DAG: 'DAG',
  INTEGRATIONS: 'integrations',
  DESCRIPTION: 'description',
  COMPONENTS: 'components',
  LINKS: 'links',
  COMPONENT_DIFF: 'component_diff',
  CONNECTORS: 'connectors',
  QNA: 'qna',
  INTEGRATION_REVIEW: 'integration_review',
  BOOMI_URL: 'https://www.boomi.com/',
  BOOMI_POLICY_URL: 'https://www.boomi.com/privacy/',
  BOOMI_STATUS_URL: 'https://status.boomi.com/',
  USER: 'user',
  PROCESS: 'process',
  FALSE: 'false',
  TRUE: 'true',
  APPLICATION_ICON_PREFIX: 'data:image/svg+xml;base64,',
};
export default AppConstants;
